import { createContext, useContext, useState, useEffect } from "react";
import { themes } from "../configs/generalConfig";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {

    const [themeId, setThemeId] = useState(() => {
        return localStorage.getItem("themeId") || "styleNarwhal";
    });

    /**
     * Applies a custum theme to the app
     * @param {Array<string>} themeArray 
     */
    function applyCustomTheme(themeArray){
        const r = document.querySelector(":root");
        r.style.setProperty("--mainColor", themeArray[0]);
        r.style.setProperty("--subColor", themeArray[1]);
        r.style.setProperty("--accentColor", themeArray[1]);
        r.style.setProperty("--bgColor", themeArray[2]);
        r.style.setProperty("--altBgColor", themeArray[3]);
        r.style.setProperty("--highlightColor", themeArray[3]);
        r.style.setProperty("--errColor", themeArray[4]);
        r.style.setProperty("--filter", themes["styleNarwhal"][5]);

        let name = "styleCustom";
        localStorage.setItem("themeId", name);
        localStorage.setItem("customTheme", JSON.stringify(themeArray));
        setThemeId(name);
    }

    /**
     * Apply theme to the entire site whenever it changes
     */
    useEffect(() => {
        const r = document.querySelector(":root");
        const theme = themes[themeId];
        if (!theme && themeId != "styleCustom") return;

        
        if(themeId == "styleCustom"){
            applyCustomTheme(JSON.parse(localStorage.getItem("customTheme")));
            console.log("doing custom theme")
        }
        else{
            r.style.setProperty("--mainColor", theme[0]);
            r.style.setProperty("--subColor", theme[1]);
            r.style.setProperty("--accentColor", theme[1]);
            r.style.setProperty("--bgColor", theme[2]);
            r.style.setProperty("--altBgColor", theme[3]);
            r.style.setProperty("--highlightColor", theme[3]);
            r.style.setProperty("--errColor", theme[4]);
            r.style.setProperty("--filter", theme[5]);
        }
        

        localStorage.setItem("themeId", themeId);
    }, [themeId]);

    return (
        <ThemeContext.Provider value={{ themeId, setThemeId, applyCustomTheme }}>
        {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}